import { dark } from '@clerk/themes';

// Clerk appearance configuration that matches your app's theme
export const clerkAppearance = {
  baseTheme: undefined, // We'll use custom variables instead
  variables: {
    colorPrimary: 'hsl(24 10% 10%)', // stone-900
    colorBackground: 'hsl(0 0% 100%)', // white
    colorText: 'hsl(20 14% 4%)', // stone-950
    colorTextSecondary: 'hsl(25 5% 45%)', // stone-500
    colorInputBackground: 'hsl(0 0% 100%)', // white
    colorInputText: 'hsl(20 14% 4%)', // stone-950
    colorDanger: 'hsl(0 84% 60%)', // red-500
    colorSuccess: 'hsl(142 71% 45%)', // green-600
    colorWarning: 'hsl(43 74% 66%)', // yellow
    colorNeutral: 'hsl(24 6% 90%)', // stone-200
    borderRadius: '0.5rem',
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    fontSize: '1rem',
  },
  elements: {
    // Root containers
    rootBox: 'w-full',
    card: 'bg-card text-card-foreground shadow-lg border border-border',
    
    // Headers
    headerTitle: 'text-xl font-semibold text-foreground',
    headerSubtitle: 'text-sm text-muted-foreground',
    
    // Buttons
    formButtonPrimary: 
      'bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
    formButtonSecondary:
      'bg-secondary text-secondary-foreground hover:bg-secondary/80 h-10 px-4 py-2 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
    formButtonReset:
      'text-primary underline-offset-4 hover:underline text-sm',
    
    // Form fields
    formFieldInput: 
      'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
    formFieldLabel: 
      'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
    formFieldError: 
      'text-sm text-destructive mt-1',
    
    // Links
    link: 'text-primary underline-offset-4 hover:underline',
    
    // Avatars
    avatarBox: 'h-10 w-10',
    avatarImage: 'rounded-full',
    
    // Badges
    badge: 'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    
    // Organization switcher
    organizationSwitcherTrigger: 'w-full justify-start px-2 py-1.5 hover:bg-accent hover:text-accent-foreground rounded-md',
    organizationSwitcherPopover: 'bg-popover text-popover-foreground',
    organizationPreview: 'hover:bg-accent hover:text-accent-foreground p-2 rounded-md cursor-pointer',
    
    // User button
    userButtonTrigger: 'focus:shadow-none',
    userButtonPopover: 'bg-popover text-popover-foreground',
    userButtonMenuItem: 'hover:bg-accent hover:text-accent-foreground',
    
    // Misc
    dividerRow: 'bg-border',
    identityPreview: 'hover:bg-accent hover:text-accent-foreground p-2 rounded-md',
    phoneInputBox: 'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm',
    messageText: 'text-sm text-muted-foreground',
    notificationBadge: 'bg-destructive text-destructive-foreground',
  },
  layout: {
    socialButtonsPlacement: 'bottom' as const,
    socialButtonsVariant: 'blockButton' as const,
  }
};

// Dark mode theme configuration
export const clerkDarkAppearance = {
  ...clerkAppearance,
  baseTheme: dark,
  variables: {
    ...clerkAppearance.variables,
    colorPrimary: 'hsl(60 9% 98%)', // stone-50
    colorBackground: 'hsl(24 10% 10%)', // stone-900
    colorText: 'hsl(60 9% 98%)', // stone-50
    colorTextSecondary: 'hsl(24 5% 64%)', // stone-400
    colorInputBackground: 'hsl(25 6% 15%)', // stone-800
    colorInputText: 'hsl(60 9% 98%)', // stone-50
    colorDanger: 'hsl(0 63% 31%)', // dark red
    colorNeutral: 'hsl(25 6% 15%)', // stone-800
  },
};